__turbopack_context__.v({
  "accommodationName": "eYO1-a_accommodationName",
  "basketImageWrapper": "eYO1-a_basketImageWrapper",
  "basketImageWrapperMobile": "eYO1-a_basketImageWrapperMobile",
  "bookingDetails": "eYO1-a_bookingDetails",
  "bookingPriceDetails": "eYO1-a_bookingPriceDetails",
  "bookingPriceDetailsLabel": "eYO1-a_bookingPriceDetailsLabel",
  "checkoutSection": "eYO1-a_checkoutSection",
  "content": "eYO1-a_content",
  "departureDate": "eYO1-a_departureDate",
  "flexColumn": "eYO1-a_flexColumn",
  "groupDetailsLabel": "eYO1-a_groupDetailsLabel",
  "groupDetailsName": "eYO1-a_groupDetailsName",
  "groupsBasketPrice": "eYO1-a_groupsBasketPrice",
  "includedServiceIcon": "eYO1-a_includedServiceIcon",
  "includedServicesWrapper": "eYO1-a_includedServicesWrapper",
  "location": "eYO1-a_location",
  "mobileContent": "eYO1-a_mobileContent",
  "mobileHeader": "eYO1-a_mobileHeader",
  "mobileTotalBottom": "eYO1-a_mobileTotalBottom",
  "mobileTotalBottomOnTop": "eYO1-a_mobileTotalBottomOnTop",
  "mobileTotalBottomPrice": "eYO1-a_mobileTotalBottomPrice",
  "rebookingBanner": "eYO1-a_rebookingBanner",
  "serviceIconDivider": "eYO1-a_serviceIconDivider",
  "serviceOverview": "eYO1-a_serviceOverview",
  "serviceOverviewBody": "eYO1-a_serviceOverviewBody",
  "serviceOverviewHeader": "eYO1-a_serviceOverviewHeader",
  "serviceOverviewItemText": "eYO1-a_serviceOverviewItemText",
  "serviceOverviewItemTextTitle": "eYO1-a_serviceOverviewItemTextTitle",
  "serviceOverviewSubItemText": "eYO1-a_serviceOverviewSubItemText",
});
